export function SectionHeader({ title, linkLabel, href = "#" }: { title: string; linkLabel?: string; href?: string }) {
  return (
    <div className="section-heading">
      <h2>{title}</h2>
      {linkLabel ? <a href={href}>{linkLabel} <span aria-hidden="true">→</span></a> : null}
    </div>
  );
}
